import first from './assets/1.png';
import second from './assets/2.png';
import third from './assets/3.png';

const digitalOwnershipSvgs = [first, second, third];

export default digitalOwnershipSvgs;
